import React from 'react';
import { FileText, Award, Newspaper, Mic } from 'lucide-react';
import { publications } from '../data/mockData';
import '../styles/PublicationsSection.css';

const PublicationsSection = () => {
  const getIcon = (type) => {
    switch(type) {
      case 'Research Paper': return FileText;
      case 'Keynote Speaker': return Mic;
      case 'Media Feature': return Newspaper;
      default: return Award;
    }
  };

  return (
    <section className="publications-section">
      <div className="publications-container">
        <div className="section-header">
          <div className="section-label">Research & Recognition</div>
          <h2 className="section-title">Publications & Talks</h2>
          <p className="section-description">
            Contributing to medical knowledge and public health awareness
          </p>
        </div>
        
        <div className="publications-grid">
          {publications.map((pub, index) => {
            const Icon = getIcon(pub.type);
            return (
              <div key={index} className="publication-card">
                <div className="pub-icon">
                  <Icon size={24} />
                </div>
                <div className="pub-content">
                  <div className="pub-type">{pub.type}</div>
                  <h3 className="pub-title">{pub.title}</h3>
                  <div className="pub-meta">
                    <span>{pub.journal || pub.conference || pub.media}</span>
                    <span className="pub-year">{pub.year}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PublicationsSection;
